import HorseHead from 'assets/images/pudzianAI/pudzianAIHorseHead.webp';
import PudzianHead from 'assets/images/pudzianAI/pudzianAIPudzianHead.webp';
import { AICampaign, AICampaignSelectedOption, AICampaignSelection } from 'features/AICampaign/interface';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { campaignAIConfig } from 'shared/constants/common';

interface Props {
	selectedOption: AICampaignSelectedOption;
	location: 'mobile-homepage' | 'payments' | 'web-coupon' | 'tabs-left' | 'tabs-right';
}

export const getSelectedCampaignOption = () => {
	try {
		const data = localStorage.getItem(campaignAIConfig.STORAGE_SELECTION_KEY);
		const parsed = data ? (JSON.parse(data) as AICampaignSelection) : null;
		return parsed?.selectedOption ?? null;
	} catch {
		return null;
	}
};

export const AICampaignIcon: React.FC<Props> = ({ selectedOption, location }) => {
	const { t } = useTranslation();
	const registrationCampaignSelection = localStorage.getItem(campaignAIConfig.STORAGE_SELECTION_KEY);

	const [campaignOption, setCampaignOption] = useState(getSelectedCampaignOption());
	const className = styles[location];

	const isCampaignEndReached = useCallback(() => {
		const parsed = registrationCampaignSelection ? (JSON.parse(registrationCampaignSelection) as AICampaignSelection) : null;
		if (!parsed) {
			return false;
		}
		const currentDate = new Date();
		const minuteDifference = (currentDate.getTime() - parsed.selectionDate) / 1000 / 60;
		return minuteDifference >= campaignAIConfig.AI_CAMPAIGN_EXPIRE_MINUTES;
	}, []);

	useEffect(() => {
		if (isCampaignEndReached()) {
			localStorage.removeItem(campaignAIConfig.STORAGE_SELECTION_KEY);
			setCampaignOption(null);
		}
	}, [campaignOption]);

	const renderCampaignIcon = () => {
		if (!campaignOption) {
			return null;
		}

		if (selectedOption === AICampaign.AI) {
			return <img src={HorseHead} alt={t('aiHorseAlt')} className={className} />;
		}

		if (selectedOption === AICampaign.INTUITION) {
			return <img src={PudzianHead} alt={t('aiPudzianAlt')} className={className} />;
		}

		return null;
	};

	return renderCampaignIcon();
};

const styles = {
	'mobile-homepage': 'size-14',
	'web-coupon': 'size-14',
	payments: `size-10 shrink-0 ${getSelectedCampaignOption() === AICampaign.INTUITION ? 'rotate-[-13.15deg]' : ''}`,
	'tabs-left': 'z-2 size-14 absolute left-0 top-1/2 -translate-y-1/2',
	'tabs-right': 'z-2 size-14 absolute right-0 top-1/2 -translate-y-1/2',
};
